import ApiService from '@/services/ApiService';
export default {
  sentContact(data) {
    return ApiService().post("/contact-pack", data, true);
  },
  sentContactPartner(data) {
    return ApiService().post("/contact-partner", data, true);
  },
};
